export * from './findById';
export * from './capitalize';
export * from './showNotify';
export * from './deviceType';
export * from './permissions';
export * from './filterByName';
export * from './filterByKeys';
export * from './formatFileSize';
export * from './getFormatDate';
export * from './mockServerApi';
export * from './objectIsEmpty';
export * from './sortItems';
export * from './removeItemInArray';
export * from './calculateEndingDate';
export * from './diff';
export * from './flattenObject';
export * from './set';
export * from './deepClone';
export * from './get';
export * from './findParentNode';
export * from './colors';
export * from './ctrlShortkey';
export * from './getSVGComponent';
export * from './axiosCache';
export * from './shortKeys';
export * from './getDataFormat';
export * from './resizeUrl';
export * from './createHistoryStore';
export * from './splitStringByLength';
export * from './buildPathFromArray';
export * from './deepEqual';
export * from './getThumbnailForVideo';
export * from './downloadLink';
export * from './checkInteractionsFiring';

export const randomId = () => (Math.random() + 1).toString(36).substring(7);
